module.exports = __webpack_public_path__ + "img/422A1E_716767_685D59_5E4F4A-256px.ebedb734.png";